import ReportViewer, {
  accountxReportUrl,
} from '@account-root/account-react/src/containers/DigitalReportModule/ReportViewer';
import MainHeader from '@ifca-root/react-component/src/components/Header/MainHeader';
import { ContentWrapper } from '@ifca-root/react-component/src/components/Layout/ContentWrapper';
import { useHistory, useLocation } from 'react-router';
import { formatDashDate } from 'helpers/StringNumberFunction/FormatDate';
import React from 'react';

export const FALedgerReportByTransactionDate = () => {
  const history = useHistory();
  const user = JSON.parse(localStorage.getItem('loggedInUser'));
  const accountID = user.accountID;
  let location = useLocation();
  const editData = location?.state as any;

  const parameters = [
    { name: 'p_accountid', value: accountID },
    { name: 'p_companyid', value: editData?.CompanyID },
    { name: 'p_assettype', value: editData?.AssetType },
    { name: 'p_assetcardno', value: editData?.AssetCardNo },
    { name: 'p_docno', value: editData?.DocNo },
    { name: 'p_costcentreid', value: editData?.CostCentreID },
    { name: 'p_locationid', value: editData?.LocationID },
    {
      name: 'p_startdate',
      value: editData?.StartDate
        ? formatDashDate(new Date(editData?.StartDate).toISOString())
        : null,
    },
    {
      name: 'p_enddate',
      value: editData?.EndDate
        ? formatDashDate(new Date(editData?.EndDate).toISOString())
        : null,
    },
  ];

  const generatedurl = (reportName, parameters) => {
    let reporturl = reportName;

    parameters?.map((x, index) => {
      const symbol = index === 0 ? '?' : '&';
      if (x?.value !== undefined)
        reporturl = reporturl + symbol + x?.name + '=' + x?.value;
    });
    return reporturl;
  };

  return (
    <>
      <MainHeader
        onClick={() => history.push(`/digital-reports/fixed-assets`)}
        mainBtn="close"
        smTitle="Fixed Assets"
        title={user?.companyName}
        routeSegments={[
          { name: 'Main Menu' },
          { name: 'Submenu' },
          { name: 'Parameters' },
          { name: 'FA Ledger Report By Transaction Date', current: true },
        ]}
        rightRouteSegments={[{ name: 'Report', current: true }]}
      />
      <ContentWrapper style={{ maxHeight: '100%' }}>
        {ReportViewer({
          url: generatedurl('FALedgerReportByTransactionDate', parameters),
          host: accountxReportUrl,
          excludedExportFormat: [],
        })}
      </ContentWrapper>
    </>
  );
};
